var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1,
    height: 6,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 1,
    height: 10,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1,
    height: 1,
    transform: "rotate(90 9 3)",
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1,
    transform: "rotate(90 9 8)",
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 1,
    height: 1,
    transform: "rotate(90 11 10)",
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 1,
    height: 1,
    transform: "rotate(90 11 1)",
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 1,
    height: 1,
    transform: "rotate(90 2 1)",
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 1,
    height: 1,
    transform: "rotate(90 2 10)",
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6,
    transform: "matrix(-1 0 0 1 3 3)",
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 10,
    transform: "matrix(-1 0 0 1 1 1)",
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 3 3)",
    fill: "currentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 3 8)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleS);
export default __webpack_public_path__ + "static/media/rectangle-s.aaba42aef411094811b5538f2894cc3a.svg";
export { ForwardRef as ReactComponent };